<mat-card class="mb-3">
  <mat-card-header>
    <mat-card-title>Skema kopiering</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div fxFlex="30" fxLayout="column">
      <div fxFlex fxLayout="column">
        <mat-form-field>
          <mat-select
            [formControl]="form.controls.id"
            placeholder="Vælg skema"
            >
            @for (questionnaire of questionnaires$ | async; track questionnaire) {
              <mat-option
                [value]="questionnaire.id"
              >{{questionnaire.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex fxLayout="column">
        <mat-form-field>
          <mat-select
            [formControl]="form.controls.target"
            placeholder="Vælg fond"
            >
            @for (customer of customers$ | async; track customer) {
              <mat-option
                [value]="customer.subdomain"
              >{{customer.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div fxFlex fxLayout="column"></div>
  </mat-card-content>
  <mat-card-actions class="questionnaire-clone-actions">
    @if (form.enabled) {
      <button
        mat-stroked-button
        [disabled]="form.invalid"
        (click)="clone()"
      >Kopier</button>
    }
    @if (form.disabled) {
      <mat-progress-spinner
        color="accent"
        [diameter]="24"
        mode="indeterminate"
      ></mat-progress-spinner>
    }
  </mat-card-actions>
</mat-card>
